import type React from 'react';
import { useState } from 'react';
import type { TagShort } from '@pages/User/components/tags/types';
import { useCreateTag, useDeleteTag, useUpdateTag } from '@queries/fetchTags';

import InputText from '../../../../components/InputText';
import Modal from '../../../../components/Modal';

const TagModal = ({
  tag = {
    id: '',
    label: '',
    created_at: '',
  },
  handleClose,
  isAdd,
}: {
  tag: TagShort;
  handleClose: () => void;
  isAdd: boolean;
}) => {
  const [formValues, setFormValues] = useState(tag);
  const createTagMutation = useCreateTag();
  const updateTagMutation = useUpdateTag();
  const deleteTagMutation = useDeleteTag();

  const handleChangeTagLabel = ({ target }: React.ChangeEvent<HTMLInputElement>) =>
    setFormValues({ ...formValues, label: target.value });

  const handleSubmit = () => {
    handleClose();
    if (isAdd) {
      createTagMutation.mutate({ label: formValues.label });
    } else {
      updateTagMutation.mutate({ id: formValues.id, label: formValues.label });
    }
  };

  const removeTag = () => {
    handleClose();
    deleteTagMutation.mutate(tag.id);
  };

  return (
    <Modal
      open
      className="w-full gap-0.5 sm:w-5/6 sm:max-w-full lg:w-1/2"
      onClose={handleClose}
      title={isAdd ? 'Create tag' : 'Edit tag'}
    >
      <InputText labelText="Label" maxLength={50} isRequired value={formValues.label} onChange={handleChangeTagLabel} />
      {isAdd ? (
        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <button
            disabled={!formValues.label?.trim()}
            onClick={handleSubmit}
            type="button"
            className="bg-primary-600 hover:bg-primary-700 focus:ring-primary-500 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-xs focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Create
          </button>
          <button
            onClick={handleClose}
            type="button"
            className="border-info-300 text-info-700 hover:bg-info-50 focus:ring-primary-500 mt-3 inline-flex w-full justify-center rounded-md border bg-white px-4 py-2 text-base font-medium shadow-xs focus:ring-2 focus:ring-offset-2 focus:outline-hidden sm:mt-0 sm:w-auto sm:text-sm"
          >
            Cancel
          </button>
        </div>
      ) : (
        <div className="flex flex-row">
          <div className="w-1/2 basis-1/2">
            <div className="mt-5 sm:mt-4 sm:flex">
              <button
                onClick={removeTag}
                type="button"
                className="bg-error-600 hover:bg-error-700 focus:ring-error-500 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-xs focus:ring-2 focus:ring-offset-2 focus:outline-hidden sm:w-auto sm:text-sm"
              >
                Delete
              </button>
            </div>
          </div>
          <div className="w-1/2 basis-1/2">
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                onClick={handleSubmit}
                disabled={!formValues.label?.trim()}
                type="button"
                className="bg-primary-600 hover:bg-primary-700 focus:ring-primary-500 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-xs focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 sm:ml-3 sm:w-auto sm:text-sm"
              >
                Submit
              </button>
              <button
                onClick={handleClose}
                type="button"
                className="border-info-300 text-info-700 hover:bg-info-50 focus:ring-primary-500 mt-3 inline-flex w-full justify-center rounded-md border bg-white px-4 py-2 text-base font-medium shadow-xs focus:ring-2 focus:ring-offset-2 focus:outline-hidden sm:mt-0 sm:w-auto sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default TagModal;
